var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:_vm.show ? 'show' : 'none',attrs:{"id":"snackbar"},domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }